module.exports = __webpack_public_path__ + "static/media/north_bengal.cd4335b5.jpeg";